import { render, staticRenderFns } from "./UsersGroupsSvg.vue?vue&type=template&id=2e977935"
import script from "./UsersGroupsSvg.vue?vue&type=script&lang=js"
export * from "./UsersGroupsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports